import{jsx as e}from"react/jsx-runtime";import t from"./EmptyPlaceholder.module.scss.js";const l=({columnsCount:l,emptyContent:o})=>o?e("tr",{children:e("td",{className:t.emptyPlaceholder,colSpan:l,children:o})}):null;export{l as default};
